import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpAdjustmentPage } from '@/features/marketPromotion/pages/MpAdjustmentPage';
import { mpReportSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';

export const Route = createFileRoute('/_auth/market-promotion/adjustment/')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.ADJUSTMENT_VIEW),
  validateSearch: mpReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Adjustment">
      <Suspense fallback={<PageLoader />}>
        <MpAdjustmentPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
